import type { LayerSpecification, StyleSpecification } from "maplibre-gl";
import type { AnyLayer } from "./paths";
import type { ColorPath } from "./types";

// How far other layers fade while a colour is pointed at.
export const SPOTLIGHT_DIM = 0.15;

const OPACITY_PROPS: { [type: string]: string[] } = {
  background: ["background-opacity"],
  fill: ["fill-opacity"],
  line: ["line-opacity"],
  symbol: ["text-opacity", "icon-opacity"],
  circle: ["circle-opacity", "circle-stroke-opacity"],
  "fill-extrusion": ["fill-extrusion-opacity"],
  raster: ["raster-opacity"],
  heatmap: ["heatmap-opacity"],
};

export function spotlightLayers(paths: ColorPath[]): Set<string> {
  return new Set(paths.map((target) => target.layerId));
}

// The style as shown while the user points at a colour: the layers that use
// it stay as they are, everything else fades. For display only; never saved.
export function spotlight<S extends StyleSpecification>(style: S, layerIds: Set<string>): S {
  const layers = style.layers.map((layer) => {
    if (layerIds.has(layer.id)) return layer;
    const props = OPACITY_PROPS[layer.type];
    if (!props) return layer;
    const paint = { ...((layer as AnyLayer).paint || {}) };
    props.forEach((prop) => {
      paint[prop] = SPOTLIGHT_DIM;
    });
    return { ...layer, paint } as LayerSpecification;
  });
  return { ...style, layers };
}
